var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[[_c('list-group',{attrs:{"title":'ランキング'}},[_c('list-item',{attrs:{"spanText":'Q. ',"text":'ランキング画面の毎週と毎月の対象期間は？',"urlName":'Help12'}})],1)]],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02113d36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HelpCategory12.vue
// module id = Ffmi
// module chunks = 0